module.exports = __webpack_public_path__ + "img/wealthmiddle2.90956cc3.png";